// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"14":"tv","278":"screen-1","328":"admin","934":"screen-2"}[chunkId] + "." + {"14":"5046fcd8","278":"5046fcd8","328":"b8de0828","934":"5046fcd8"}[chunkId] + ".css";
};